import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { PanelInstrucionHands } from "../../../components/common/PanelInstrucionHands";
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { team3_sub3_act_2_01, team3_sub3_act_2_02, team3_sub3_act_2_03, team3_sub3_act_2_04, team3_sub3_act_2_05 } from '../../../assets/imgIntruction/tema3';
import { ModalInfo } from '../../../components/common/ModalInfo';
import { voicesTypeControl } from '../../../types/audioType';
import { ButtonReturn } from '../../../components/common/ButtonReturn';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	panelInstructionOne: 3,
	panelInstructionTwo: 4,
	panelModalFloor: 5,
	panelModalBag: 6,
	panelModalWindows: 7,
	panelInstructionThree: 8,
	panelInstructionFour: 9,
	panelInstructionFive: 10,
	panelModalCooler: 11,
	panelModalFloorTwo: 12,
	panelModalClean: 13,
	panelModalBathroom: 14,
	panelModalChemicals: 15,
	win: 16
};


const stepThree = {
	click_panel_floor: steps.panelModalFloor,
	click_panel_bag: steps.panelModalBag,
	click_panel_Windows: steps.panelModalWindows,
	go_store: steps.panelInstructionThree,
	view_cooler: steps.panelModalCooler,
	view_floor: steps.panelModalFloorTwo,
	view_clean: steps.panelModalClean,
	view_bathroom: steps.panelModalBathroom,
	view_chemicals: steps.panelModalChemicals,
};


export const Theme3SubtopicThreeActivityTwo = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema3.activities.subtema3], 2);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 3 sub 3 act 2");
			ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 2);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T3.subtema_3.actividad_2.sub3_act2_a01T3)
	})

	ObserverEmitter.on(EVENTS.tema3.topic3.actTwo.finishActScene, (step = "") => {
		const stepSelect = stepThree[step]
		if (!stepSelect) {
			return
		}
		setUiToShow(stepSelect)

	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema3.topic3.initScene, 2);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name="Actividad 2: Limpieza: Exterior" />
					<DialogBarNew
						dialog={`Ahora vamos a adentrarnos más en temas de limpieza, ¿listo para continuar?`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel)
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 3: Inocuidad "
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							// ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T2.introduccion.intro01T2)
							setUiToShow(steps.panelInstructionOne);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === -2 && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
				</>
			)}
			{uiToShow === steps.panelInstructionOne && (
				<>

					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.panelInstructionTwo);
						}}
						img={team3_sub3_act_2_01}
					/>
				</>
			)}

			{uiToShow === steps.panelInstructionTwo && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "click_panel_floor")
							setUiToShow(-2);
						}}
						img={team3_sub3_act_2_02}
					/>
				</>
			)}

			{uiToShow === steps.panelModalFloor && (
				<>
					<ModalInfo
						title="Mantenimiento del área externa"
						description="Banquetas, estacionamiento, y equipos limpios y en buen estado. Cajón y rampa para personas con discapacidad señalizadas. "
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "click_panel_bag")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalBag && (
				<>
					<ModalInfo
						title="Mantenimiento del área externa"
						description="Contenedor y botones de basura tapados y limpios. Botones de basura sin exceso y libre de mal olor."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "click_panel_Windows")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalWindows && (
				<>
					<ModalInfo
						title="Mantenimiento del área externa"
						description="Ventanales y puertas de acceso limpias (Por dentro y fuera). Anuncios en buen estado, limpios y funcionando."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "go_store")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelInstructionThree && (
				<>
					<PanelInstrucionHands
						text="Toca y arrastra con tu dedo para girar la vista."
						action={() => {
							setUiToShow(steps.panelInstructionFour);
						}}
						img={team3_sub3_act_2_03}
					/>
				</>
			)}

			{uiToShow === steps.panelInstructionFour && (
				<>
					<PanelInstrucionHands
						text="Pellizca la pantalla para acercar o alejar la vista."
						action={() => {
							setUiToShow(steps.panelInstructionTwo);
							setUiToShow(steps.panelInstructionFive);
						}}
						img={team3_sub3_act_2_04}
					/>
				</>
			)}
			{uiToShow === steps.panelInstructionFive && (
				<>
					<PanelInstrucionHands
						text="Explora tocando las áreas iluminadas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "view_cooler")
							setUiToShow(-1);
						}}
						img={team3_sub3_act_2_05}
					/>
				</>
			)}

			{uiToShow === steps.panelModalCooler && (
				<>
					<ModalInfo
						title="Mantenimiento del área Interna"
						description="Hieleras y exhibidores de piso limpios. Piso de venta libre de bultos y cajas."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "view_floor")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalFloorTwo && (
				<>
					<ModalInfo
						title="Mantenimiento del área Interna"
						description="Pisos y tapete limpios. Olor agradable o neutro."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "view_clean")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalClean && (
				<>
					<ModalInfo
						title="Mantenimiento del área Interna"
						description="Isla limpia y libre de objetos no autorizados."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "view_bathroom")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalBathroom && (
				<>
					<ModalInfo
						title="Mantenimiento del área Interna"
						description="Baño con olor agradable. Todos los componentes del sanitario limpios."
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene, "view_chemicals")
							setUiToShow(-1);
						}}
					/>
				</>
			)}

			{uiToShow === steps.panelModalChemicals && (
				<>
					<ModalInfo
						title="Mantenimiento del área Interna"
						description="Químicos de la limpieza colocados en la canastilla que se encuentra sobre la tarja. Bodega limpia. "
						action={() => {
							ObserverEmitter.emit(EVENTS.tema3.topic3.actTwo.actScene)
							setUiToShow(steps.win);
						}}
					/>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Recuerda que la limpieza es nuestra carta de presentación ante el cliente."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 2,
									pointsWin: 0,
									subtema: tasksId.tema3.activities.subtema3
								})
							);
							navigator("/home3/tema3/subtema3/activityThree");
						}}
					/>
				</>
			)}
		</>
	)
}